import axios from "axios";
import { API_V7_URL } from "../constants/Globals";

export const getSequenceById = (id) => {
  return axios.get(`${API_V7_URL}/api/sequences/${id}`);
};

export const updateSequenceById = (id, data) => {
  return axios.put(`${API_V7_URL}/api/sequences/${id}`, data);
};
export const updateIsDraftById = (id, data) => {
  return axios.put(`${API_V7_URL}/api/sequences/${id}/draft`, data);
};
export const addNewSequence = (data) => {
  return axios.post(`${API_V7_URL}/api/sequences`, data);
};

export const addStepToSequence = (data) => {
  return axios.post(`${API_V7_URL}/api/sequence/steps/stepAndPart`, data);
};

export const addBranchToStep = (id, data) => {
  return axios.post(`${API_V7_URL}/api/sequence/steps/${id}/branches`, data);
};

export const deleteStepHierarchy = (stepId) => {
  return axios.delete(`${API_V7_URL}/api/sequence/steps/${stepId}`);
};

export const deleteBranchHierarchy = (branchId) => {
  return axios.delete(`${API_V7_URL}/api/sequence/steps/branch/${branchId}`);
};

export const updateAndThenInfo = (stepId, nextStepId) => {
  return axios.post(
    `${API_V7_URL}/api/sequence/steps/${stepId}/andThen/${nextStepId}`
  );
}
